/**
 * DashboardFooter Component
 * Footer with disclaimer and copyright information
 * Mobile-responsive design
 */
import React from 'react';

const DashboardFooter = () => {
  return (
    <footer className="bg-[#0A1929] border-t border-[#2D5A8F] px-3 sm:px-6 py-3 sm:py-4">
      <div className="max-w-7xl mx-auto">
        {/* Platform Disclaimer */}
        <div className="mb-2 sm:mb-3 p-2 sm:p-3 bg-[#1A2942]/50 rounded-lg border border-[#2D5A8F]">
          <p className="text-gray-500 text-[9px] sm:text-[10px] leading-relaxed">
            <strong className="text-gray-400">Disclaimer:</strong> MDRT School and Financial Nirvana do not provide any financial, investment, legal, or tax advisory services. We are a capability development and education platform offering tools, technology, and training exclusively for financial services sales professionals. Any decisions taken based on the use of our content, tools, or programmes are solely the responsibility of the user.
          </p>
        </div>
        
        {/* Investment Disclaimer - Hidden on very small screens, collapsible */}
        <details className="text-gray-500 text-[9px] sm:text-xs leading-relaxed mb-2 sm:mb-3">
          <summary className="cursor-pointer text-gray-400 text-[10px] sm:text-xs font-medium">
            Investment Disclaimer (tap to expand)
          </summary>
          <p className="mt-2 text-center">
            The information provided in this financial planning tool is for general informational purposes only and does not constitute financial, investment, tax, or legal advice. 
            Past performance is not indicative of future results. All investment decisions should be made after consulting with a qualified financial advisor. 
            Mutual fund investments are subject to market risks. Please read all scheme-related documents carefully before investing.
          </p>
        </details>
        
        {/* Copyright */}
        <div className="text-center">
          <p className="text-gray-400 text-[10px] sm:text-xs">
            © 2026 Arth Gurukul | Tech, Tools &amp; Training Powered by MDRT School | By Financial Nirvana
          </p>
          <p className="text-[#FFD700] text-[10px] sm:text-xs mt-0.5 sm:mt-1">
            Your School for Lifelong Financial Wellness
          </p>
        </div>
      </div>
    </footer>
  );
};

export default DashboardFooter;
